import LegalLayout from "./LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026" canonical="https://spherehyx.com/privacy">
      <p>SphereHyx ("we", "us") provides sports club management software to clubs, coaches, parents and athletes. This policy explains what personal information we collect, why we collect it, and the choices you have. By creating an account or registering an athlete, you agree to this policy.</p>

      <h2>Information we collect</h2>
      <ul>
        <li><b>Account details</b> — name, email, phone and role (coach, parent, player).</li>
        <li><b>Athlete profiles</b> — name, date of birth, photo, jersey number, position, team, and emergency contact. For minors, this is provided by a parent or guardian.</li>
        <li><b>Health &amp; safety information</b> — allergies and medical notes you choose to add, used only to keep athletes safe during activities.</li>
        <li><b>Payment information</b> — fees and subscriptions are processed by our payment provider, <b>Stripe</b>. We never see or store full card numbers.</li>
        <li><b>Usage data</b> — basic technical logs (device, browser, pages) to keep the service secure and reliable.</li>
      </ul>

      <h2>How we use your information</h2>
      <ul>
        <li>To run your club: rosters, attendance, scheduling, performance and communications.</li>
        <li>To process payments, subscriptions and send receipts.</li>
        <li>To send service messages (e.g. fee reminders, match info) and, where permitted, updates.</li>
        <li>To keep athletes safe and to secure and improve the platform.</li>
      </ul>

      <h2>Children's data</h2>
      <p>Athlete profiles for minors are created and managed by a parent, guardian or authorised club staff. We collect this information solely to operate the club's activities. A parent or guardian may review, update or request deletion of their child's information at any time by contacting their club or us.</p>

      <h2>How we share information</h2>
      <p>We do <b>not</b> sell your personal information. We share it only with: your club and its authorised staff; service providers who help us run the platform (e.g. Stripe for payments, email delivery); and authorities where required by law. Each club is responsible for the data of its own members.</p>

      <h2>Payments &amp; refunds</h2>
      <p>Payments are handled securely by Stripe. If you are <b>overcharged or charged twice</b>, you are entitled to a refund — contact your club (coaches can issue a refund directly from their dashboard) or email us and we will help resolve it. See our <a href="/terms">Terms &amp; Conditions</a> for full details.</p>

      <h2>Data retention &amp; security</h2>
      <p>We keep information for as long as your club uses the service, then delete or anonymise it within a reasonable period. We use encryption in transit and access controls to protect your data.</p>

      <h2>Your rights</h2>
      <p>You may request access to, correction of, or deletion of your personal information, and you may object to certain processing. Contact us at <a href="mailto:support@spherehyx.com">support@spherehyx.com</a> and we will respond promptly.</p>

      <h2>Changes</h2>
      <p>We may update this policy from time to time. Material changes will be posted here with a new "last updated" date.</p>
    </LegalLayout>
  );
}
